import axios, { AxiosResponse } from "axios";

import { IPaginationConfig } from "./stats-external-admin.types";

export const loadRegionData = async (): Promise<AxiosResponse> => {
    return axios.request({
        method: "GET",
        url: `/services/isnaportal/open-api/tax-org/search`,
        params: {
            levels: "1,2",
        },
    });
};

export const saveFile = (data: Blob, type: string, title = "template.xlsx") => {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = title;
    link.click();
    link.remove();
};

export const downloadDocumentTrade = (fileId: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/international-trade-report/download/${fileId}`, {
        responseType: "arraybuffer",
    });
};

export const uploadDocumentTrade = (data: any): Promise<AxiosResponse> => {
    return axios.post(`/services/isnaportal/api/international-trade-report`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

// index

export const searchIndex = (config?: IPaginationConfig): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/international-trade-index`, {
        params: {
            ...config,
        },
    });
};

export const downloadDocumentIndex = (fileId: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/international-trade-index/download/${fileId}`, {
        responseType: "arraybuffer",
    });
};

export const uploadDocumentIndex = (data: any): Promise<AxiosResponse> => {
    return axios.post(`/services/isnaportal/api/international-trade-index`, data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const deleteIndex = (id: number): Promise<AxiosResponse> => {
    return axios.delete(`/services/isnaportal/api/international-trade-index/${id}`);
};




